// ============================================================================
// Canonical genre taxonomy — SINGLE SOURCE OF TRUTH for genre browsing.
// Uses TMDB genre names. This same list will later power film-community
// categories, so do NOT hardcode genre names anywhere else.
// ============================================================================
export const GENRES = [
  { slug: "action", name: "Action" },
  { slug: "adventure", name: "Adventure" },
  { slug: "animation", name: "Animation" },
  { slug: "comedy", name: "Comedy" },
  { slug: "crime", name: "Crime" },
  { slug: "documentary", name: "Documentary" },
  { slug: "drama", name: "Drama" },
  { slug: "family", name: "Family" },
  { slug: "fantasy", name: "Fantasy" },
  { slug: "history", name: "History" },
  { slug: "horror", name: "Horror" },
  { slug: "music", name: "Music" },
  { slug: "mystery", name: "Mystery" },
  { slug: "romance", name: "Romance" },
  { slug: "sci-fi", name: "Sci-Fi" },
  { slug: "thriller", name: "Thriller" },
  { slug: "war", name: "War" },
  { slug: "western", name: "Western" },
];

export const GENRE_BY_SLUG = Object.fromEntries(GENRES.map((g) => [g.slug, g]));

// TMDB display names (incl. TV combo names) -> canonical slug.
const ALIAS = {
  "science fiction": "sci-fi",
  "sci-fi & fantasy": "sci-fi",
  "action & adventure": "action",
  "war & politics": "war",
  "tv movie": "drama",
  kids: "family",
};

export function genreToSlug(name) {
  if (!name) return "";
  const k = String(name).trim().toLowerCase();
  if (ALIAS[k]) return ALIAS[k];
  return k
    .replace(/\s*&\s*/g, "-")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function genreName(slug) {
  if (GENRE_BY_SLUG[slug]) return GENRE_BY_SLUG[slug].name;
  return slug ? slug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "";
}
